module.exports = __webpack_public_path__ + "static/media/man.5896d3f9.jpeg";